import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import Btn from 'components/buttons/Btn'
import { BtnDesc, FormCollapse, FormTip, NumberSpinner } from 'components/form'
import I from 'components/I'
import { Badge, Card, Col, Form, Row } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Order from 'state/models/Order'
import { searchPrinters, setCopies, togglePrinter, usePrinters } from 'state/Printers'
import { publicURL, StarPrinters, useBoolState, platform } from 'utils'

export default function PrinterSettings() {
	const { t }     = useTranslation()
	const dispatch  = useDispatch()
	const printers  = usePrinters()
	const searching = useBoolState()
	const devOrStg  = !platform.isProd()

	if (!StarPrinters.shouldBeAvailable()) {
		return null
	}

	function findStarPrinters(alert = true) { //this may also be an Event object, so we default to true to make it easier
		searching.on()
		dispatch(searchPrinters(alert, searching.off))
	}
	function doTogglePrinter(e) {
		dispatch(togglePrinter({ port: e.target.id, enabled: e.target.checked }))
	}
	function doSetCopies(port) {
		return copies => dispatch(setCopies({ port, copies }))
	}
	function doPrintTest() {
		if (!devOrStg) {
			return false
		}
		const testOrder = new Order({
			id: -735700007357, //TODO move this to a server-side constant
			number: '7357_TEST'
		})
		StarPrinters.print(testOrder)
	}

	return <Card>
		<Card.Header>
			<Row>
				<Col className="d-flex align-items-center">
					<Icon icon="receipt"/>
					<span style={{lineHeight: 1, margin: '-5px 0'}}>
						{t('Receipt printers')}<br/>
						<small>{t('(Star Micronics models)')}</small>
					</span>
					<img src={publicURL('media/star_micronics.svg')} alt="Star Micronics logo"
					     className="d-none d-xs-inline" style={{maxHeight: '1.5rem', marginLeft: 'auto'}}/>
				</Col>
				<Col xs="auto" className="embedded-btn">
					<Btn variant="secondary" onClick={findStarPrinters} title={t("Search for compatible printers")} fixedWidth
					     icon={searching.is? 'spinner' : 'print-search'} noSlash disabled={searching.is} pulse={searching.is} />
				</Col>
			</Row>
		</Card.Header>

		<Card.Body>
			{printers.length?
				<>
					<Form.Label>{t('Print orders to:')}</Form.Label>
					{printers.map(printer => (
						<Form.Group key={printer.port} className="mb-0">
							<Form.Switch onChange={doTogglePrinter} id={printer.port} defaultChecked={printer.enabled}
							             label={<>{printer.model} <small className="text-muted">({printer.port})</small></>}/>
							<FormCollapse secondary in={printer.enabled}>
									<NumberSpinner className="mb-2" value={printer.copies} min={1} size="sm" setter={doSetCopies(printer.port)} appendText={[t('copy', { context: 'printing' }), t('copies', { context: 'printing' })]}/>
							</FormCollapse>
						</Form.Group>
					))}
				</> :
				<Form.Label><I b>{t('No printers available')}</I></Form.Label>
			}
			<FormTip><Trans>You can search for compatible printers with the <BtnDesc icon="print-search"/> above.</Trans></FormTip>
			<FormTip><Trans>Orders will <b>auto-print</b> if they are within the time frame selected in the "Notify for new
						orders due" setting. You can also manually print receipts in the order's top-right menu.</Trans></FormTip>
		</Card.Body>

		{devOrStg && <Card.Footer> {/* eslint-disable-next-line i18next/no-literal-string */}
			<Btn variant="danger" onClick={doPrintTest}><Badge variant="warning">dev</Badge> Print test receipt</Btn>
		</Card.Footer>}
	</Card>
}
